import { FC } from "react"
import { BattleResultView } from "@/modals/constructor/battle/BattleResultModal/ui"
import { battleResultCopy } from "@/modals/constructor/battle/helpers"
import { useModal } from "@/modals/hooks"
import { Modal } from "@/ui/Modal"
import styles from "./BattleResultModal.module.scss"

const modalType = "battleResult"

export const BattleResultModal: FC = () => {
  const { modal, getModalParams } = useModal(modalType)
  const copy = battleResultCopy(getModalParams(modalType))

  return (
    <Modal.Center type={modalType} isCanClose={false} className={styles.raise}>
      <BattleResultView {...copy} onOk={modal.close} />
    </Modal.Center>
  )
}
